export default __webpack_public_path__ + "static/media/876.5a78ad2b.png";